(function () {
    'use strict';

    angular
        .module('franchisee-portal.filters')
        .filter('limitToCustom', LimitToCustom)

    function LimitToCustom() {
        function LimitToCustomFn(value, limit) {
            if (!value) return value;

            if (value.length > limit)
                return value.substring(0, limit) + '...';

            return value;
        }

        return LimitToCustomFn;
    }
}());